import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Button from "../component/Partial/Button";
import DeleteIcon from "../assets/Icons/DeleteIcon";
import EditIcon from "../assets/Icons/EditIcon";
import { fetchUserInfo } from "../store/actions/projectAction";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { DateFormatter, ROTUES } from "../utils/global";

function UserDetails() {
  const [userDetails, setUserDetails] = useState(null);

  const dispatch = useDispatch();
  const params = useParams();

  const init = (id) => {
    dispatch(fetchUserInfo(id))
      .unwrap()
      ?.then((data) => {
        const input = {
          projects: data?.projects ? data?.projects : [],
          user: data?.user,
        };
        setUserDetails(input);
      });
  };

  useEffect(() => {
    if (params?.id) {
      init(params?.id);
    }
  }, []);

  return (
    <div className="flex flex-col">
      <Header />
      <div className="w-full flex justify-center items-center mt-24">
        <div className="w-[95%] flex flex-col gap-6">
          <h2 className="text-2xl">User Details</h2>
          <div className="border p-4 bg-white rounded-md shadow-md">
            <p>
              <strong>Name:</strong> {userDetails?.user?.name}
            </p>
            <p>
              <strong>Email:</strong> {userDetails?.user?.email}
            </p>
            <p>
              <strong>Phone:</strong> {userDetails?.user?.phone}
            </p>
            {/* <p>
              <strong>Status:</strong> {userDetails?.user?.status}
            </p> */}
            <p>
              <strong>Registration Date:</strong>{" "}
              {DateFormatter(userDetails?.user?.createdAt)}
            </p>
          </div>

          <h2 className="text-2xl mt-8">User Projects</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead>
                <tr>
                  <th className="px-4 py-4 border-b text-left">Date</th>
                  <th className="px-4 py-4 border-b text-left">Project Name</th>
                  <th className="px-4 py-4 border-b text-left">Client Name</th>
                  <th className="px-4 py-4 border-b text-left">Client Phone</th>
                  <th className="px-4 py-4 border-b text-left">Notes</th>
                  <th className="px-4 py-4 border-b text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {userDetails?.projects.map((project, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="px-4 py-4 border-b">
                      {DateFormatter(project.createdAt)}
                    </td>
                    <td className="px-4 py-4 border-b">{project.name}</td>
                    <td className="px-4 py-4 border-b">
                      {project.client_name}
                    </td>
                    <td className="px-4 py-4 border-b">
                      {project.client_phone}
                    </td>
                    <td className="px-4 py-4 border-b">{project.notes}</td>
                    <td className="px-4 py-4 border-b">
                      <div className="flex gap-5">
                        <Link
                          to={`${ROTUES.downloadPdf}/${project?._id}`}
                          className="text-blue-500 hover:text-blue-700"
                        >
                          ⬇️
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDetails;
